/* eslint-disable max-len */
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import Table from '../components/table/table';
import { history } from '../routers/AppRouter';
import ROUTES from '../data/routes';
import { getNotificationHistoryList } from '../app/store/actions/notify';
import ModalComponent from '../components/modal';

class NotifyHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'DESC',
      field: 'createdAt',
      listHistory: [],
      userList: [],
      totalRecord: 0,
      showModal: false,
      titleModal: '',
      titleModalBody: '',
      subTableKey: '',
    };

    this.tableHeader = [
      { key: 'title', value: I18n.t('bell') },
      { key: 'description', value: I18n.t('message') },
      { key: 'sentDate', value: I18n.t('sendDate') },
      { key: 'viewPercentage', value: I18n.t('viewPercentage'), notDisplay: true },
      { key: 'runtimeAction', value: I18n.t('action') },
    ];
  }

  componentDidMount() {
    this.getNotificationHistoryList();
  }

  adjustData = async (count = 0, rows = []) => {
    const listHistory = rows.map(element => ({
      key: `NotificationHistory${element.notifyId}`,
      title: element.title,
      description: element.description,
      sentDate: moment(element.sentDate).format('L LT'),
      viewPercentage: `${element.viewPercentage.toFixed(2)} %`,
      runtimeAction: !!element.notifyUserClient.length,
      notifyUserClient: element.notifyUserClient,
    }));

    this.setState({
      totalRecord: count,
      listHistory,
    });
  }

  subTable = () => (
    <table className="table table-striped">
      <thead className="thead-dark">
        <tr>
          <th scope="col">{I18n.t('company')}</th>
          <th scope="col">{I18n.t('user')}</th>
          <th scope="col">{I18n.t('email')}</th>
          <th scope="col">{I18n.t('previewDate')}</th>
        </tr>
      </thead>
      <tbody>
        {this.state.userList.map(element => (
          <tr key={`HistoryUserList${element.notifyId}${element.clientId}${element.userId}`}>
            <td>{element.clientName}</td>
            <td>{element.userName}</td>
            <td>{element.userEmail}</td>
            <td>{element.previewDate ? moment(element.previewDate).format('L LT') : ''}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  runtimeAction = (key, element) => (
    <div className="row margin-left-0">
      <button
        type="button"
        className={`btn ${(this.state.subTableKey === key) ? 'btn-warning' : 'btn-dark'} promotion-btn-active`}
        onClick={() => {
          const subTableKey = (this.state.subTableKey === key) ? '' : key;
          this.setState({ userList: [...element.notifyUserClient], subTableKey });
        }}
      >
        {I18n.t((this.state.subTableKey === key) ? 'hide' : 'viewMore')}
      </button>
    </div>
  );

  getNotificationHistoryList = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getNotificationHistoryList(
        limit, skip, search, orderBy, field,
      );
      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error;
      if (error && error.message) {
        const messageError = (error.code && error.details)
          ? `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError,
        });
      } else {
        this.setState({
          showModal: true,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch'),
        });
      }
    }
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getNotificationHistoryList();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getNotificationHistoryList();
  }

  tableButtons = () => (
    <button
      type="button"
      onClick={() => { history.push(ROUTES.NOTIFY); }}
      className="btn btn-warning margin-right-15"
    >
      {I18n.t('return')}
    </button>
  )

  render() {
    const {
      limit, page, listHistory, totalRecord,
      titleModal, titleModalBody, showModal,
      subTableKey,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          showButtons
          confirmModal={() => this.setState({ showModal: false })}
        />
        <Table
          title={I18n.t('notificationHistory')}
          header={this.tableHeader}
          buttons={this.tableButtons()}
          lines={listHistory}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
          subTableKey={subTableKey}
          subTable={this.subTable}
          runtimeAction={this.runtimeAction}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getNotificationHistoryList: (limit, skip, search, orderBy, field) => dispatch(getNotificationHistoryList(limit, skip, search, orderBy, field)),
});

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(NotifyHistoryPage);
